import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }
  handleError(error: any): void {
    console.error(error);
    this.injector.get<ApplicationInsightsService>(ApplicationInsightsService).logException(error);
  }
}
